import React from 'react';

const Clock = ({ date, time }) => {
    return (
        <div className="clock">
            <span className="time">{time}</span>
            <span className="date">{date}</span>
        </div>
    );
};

export default Clock;


// WEBPACK FOOTER //
// ./src/components/dashboard/header/Clock.js